import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Header,
  Footer
} from './index';
import BrowserLocalRecordingRecoveryPrompt from './BrowserLocalRecordingRecoveryPrompt';
import {
  AvailableBrowserLocalRecordingRecovery,
  defaultBrowserLocalRecordingRecovery,
} from '../utils/browserLocalRecordingRecovery';

// Generate conversation ID
const generateConversationId = () => {
  // Generate a 32-character hex string (like uuid.uuid4().hex)
  return Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
};

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [recoverableRecording, setRecoverableRecording] = useState<AvailableBrowserLocalRecordingRecovery | null>(null);
  const [isInspectingRecovery, setIsInspectingRecovery] = useState(true);

  useEffect(() => {
    let isMounted = true;

    defaultBrowserLocalRecordingRecovery.findRecoverableRecording('conversation')
      .then((recording) => {
        if (isMounted) {
          setRecoverableRecording(recording);
          setIsInspectingRecovery(false);
        }
      })
      .catch((error) => {
        console.warn('Could not inspect browser-local recording recovery:', error);
        if (isMounted) {
          setIsInspectingRecovery(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  // Start recording session
  const startRecording = () => {
    const conversationId = generateConversationId();
    navigate(`/${conversationId}/record`);
  };

  const restoreRecording = () => {
    if (!recoverableRecording) return;

    navigate(`/${recoverableRecording.metadata.conversationId}/record`);
  };

  const discardRecording = async () => {
    if (!recoverableRecording) return;

    await defaultBrowserLocalRecordingRecovery.discard(
      recoverableRecording.metadata.conversationId,
      recoverableRecording.metadata.recordingType
    );
    setRecoverableRecording(null);
    setIsInspectingRecovery(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-2xl text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Gesprekskompas
          </h2>
          <p className="text-lg text-gray-600 mb-12">
            Actieve opname....
          </p>

          {isInspectingRecovery ? (
            <p className="text-sm text-gray-500">Controleren op herstelbare opname…</p>
          ) : recoverableRecording ? (
            <BrowserLocalRecordingRecoveryPrompt
              title="De gespreksopname is gepauzeerd."
              description="Dit gesprek is eerder gestart en actief gepauzeerd of door een probleem met internet afgebroken."
              durationMs={recoverableRecording.metadata.durationMs}
              onRestore={restoreRecording}
              onDiscard={discardRecording}
            />
          ) : (
            <button
              onClick={startRecording}
              className="px-8 py-4 bg-brand-blauw hover:bg-brand-blauw/90 text-brand-beige rounded-lg font-medium transition-colors"
            >
              Start Opname
            </button>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HomePage; 
